import React from 'react'
import PropTypes from 'prop-types'
import { Tag, Empty } from 'antd'

const Section = ({ title, children }) =>
  children ? (
    <div style={{ marginTop: 14 }}>
      <div
        style={{
          fontSize: 12,
          color: '#94a3b8',
          textTransform: 'uppercase',
          letterSpacing: 0.4,
          marginBottom: 4,
        }}
      >
        {title}
      </div>
      <div style={{ fontSize: 13, color: '#334155', lineHeight: 1.55, whiteSpace: 'pre-wrap' }}>
        {children}
      </div>
    </div>
  ) : null
Section.propTypes = { title: PropTypes.node, children: PropTypes.node }

// Approved Career Path result: AI insights + the counselor's recommended careers.
const CareerPathResultView = ({ result, careers }) => {
  const list = careers || []
  if (!result && !list.length) {
    return <Empty description="No career result available." />
  }
  return (
    <div>
      {list.length ? (
        <div>
          <div
            style={{
              fontSize: 12,
              color: '#94a3b8',
              textTransform: 'uppercase',
              letterSpacing: 0.4,
              marginBottom: 8,
            }}
          >
            Recommended careers
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {list.map((c) => (
              <Tag
                key={c.id ?? c.publicId ?? c.name}
                color="geekblue"
                style={{ padding: '4px 10px', fontSize: 13 }}
              >
                {c.displayValue || c.name}
              </Tag>
            ))}
          </div>
        </div>
      ) : null}
      {result ? (
        <>
          <Section title="Summary">{result.summary}</Section>
          <Section title="Strengths">{result.strengths}</Section>
          <Section title="Development areas">{result.developmentAreas}</Section>
          <Section title="Career interests">{result.careerInterestInsights}</Section>
          <Section title="Next steps">{result.nextSteps}</Section>
        </>
      ) : null}
    </div>
  )
}

CareerPathResultView.propTypes = {
  result: PropTypes.object,
  careers: PropTypes.array,
}

export default CareerPathResultView
